import { getDealerFeeData, getDealerFeeAmount } from '|/helpers/dealer-fees';
import { DueBreakdownRow, PriceDetailsView } from './derive-price-details';

export interface PriceDetailsEventMetadata {
  totalPurchasePriceDisplayed: number;
  totalPriceWithTradeInDisplayed: number;
  monthlyPaymentDisplayed: number | null;
  paymentTypeDisplayed: string | null;

  transferLabelDisplayed: string | null;
  transferAmountDisplayed: number | null;

  carvanaCarePriceDisplayed: number | null;
  carvanaCareDeclined: boolean | null;
  gapPriceDisplayed: number | null;
  gapDeclined: boolean | null;

  tradeInAmountDisplayed: number | null;
  tradeInDeclined: boolean | null;

  cashDownDisplayed: number | null;
  cashDownLabelDisplayed: string | null;
  nrsfDisplayed: number | null;
  creditFromPreviousOrderDisplayed: number | null;

  feeBasedState: string | null;
  maxDealerFeeDisplayed: number | null;
}

const dueRow = (view: PriceDetailsView, id: DueBreakdownRow['id']) =>
  view.dueBreakdown.find(row => row.id === id) ?? null;

const dueAmount = (view: PriceDetailsView, id: DueBreakdownRow['id']) =>
  dueRow(view, id)?.amount ?? null;

export const derivePriceDetailsEventMetadata = (
  view: PriceDetailsView,
  userState?: string | null
): PriceDetailsEventMetadata => {
  const stateData = userState ? getDealerFeeData(userState) : undefined;

  return {
    totalPurchasePriceDisplayed: view.totalPurchasePrice,
    totalPriceWithTradeInDisplayed: view.totalPriceWithTradeIn,
    monthlyPaymentDisplayed: view.showFinance ? view.monthlyPayment : null,
    paymentTypeDisplayed: view.showFinance ? view.paymentTypeLabel : null,

    transferLabelDisplayed: view.transferLabel,
    transferAmountDisplayed: view.transferAmount,

    carvanaCarePriceDisplayed: view.carvanaCare?.amount ?? null,
    carvanaCareDeclined: view.carvanaCare?.isDeclined ?? null,
    gapPriceDisplayed: view.gap?.amount ?? null,
    gapDeclined: view.gap?.isDeclined ?? null,

    tradeInAmountDisplayed: view.showTradeIn ? view.tradeIn.amount : null,
    tradeInDeclined: view.showTradeIn ? view.tradeIn.isDeclined : null,

    cashDownDisplayed: dueAmount(view, 'down'),
    cashDownLabelDisplayed: dueRow(view, 'down')?.title ?? null,
    nrsfDisplayed: dueAmount(view, 'shipping'),
    creditFromPreviousOrderDisplayed: dueAmount(view, 'refund'),

    feeBasedState: stateData ? stateData.stateCode : userState ?? null,
    maxDealerFeeDisplayed: stateData ? getDealerFeeAmount(stateData) : null
  };
};

export default derivePriceDetailsEventMetadata;
